import React, { useEffect, useState } from "react";
import ReusableMuiTable from "../../../components/common/Table/Table";
import Box from "@mui/material/Box";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getService,deleteServiceList } from "../../../api/service/serviceapi";

const ServiceListing = () => {
  const navigate = useNavigate();

  const [services, setServices] = useState([]);
  const [page, setPage] = useState(0); 
  const [rowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchServices = async (pageNumber = 1) => {
    try {
      setLoading(true);
      const res = await getService({
        page: pageNumber,
        limit: rowsPerPage,
      });

      setServices(res.data.data);
      setTotalCount(res.data.total);
    } catch (error) {
      console.error("Failed to fetch services", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices(page + 1);
  }, [page]);

  const addService = () => {
    navigate("/add-service");
  };

  const handleEdit = (rowData) => {
    navigate(`/update-service/${rowData.id}`);
  };

const handleDelete = (rowData) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#C39B22",
    cancelButtonColor: "#d32f2f",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await deleteServiceList(rowData.id);

        Swal.fire({
          title: "Deleted!",
          text: "Service has been deleted successfully.",
          icon: "success",
          confirmButtonColor: "#C39B22",
        });

 
        const isLastItemOnPage = services.length === 1 && page > 0;
        const newPage = isLastItemOnPage ? page - 1 : page;

        setPage(newPage);
        fetchServices(newPage + 1);
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to delete service.",
          icon: "error",
        });
      }
    }
  });
};


  const columns = [
    {
      name: "name",
      label: "Service Title",
    },
    {
      name: "description",
      label: "Service Description",
      options: {
        customBodyRender: (value) =>
          value?.length > 80 ? `${value.substring(0, 80)}...` : value,
      },
    },
    {
      name: "icon",
      label: "Service Banner",
      options: {
        customBodyRender: (icon) =>
          icon?.url ? (
            <img
              src={icon.url}
              alt="service"
              style={{ width: 50, height: 50, objectFit: "contain" }}
            />
          ) : (
            "-"
          ),
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const rowData = services[dataIndex];
          return (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Tooltip title="Edit">
                <IconButton size="small" onClick={() => handleEdit(rowData)}>
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => handleDelete(rowData)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      },
    },
  ];

  return (
    <ReusableMuiTable
      title="Service Listing"
      data={services}
      columns={columns}
      loading={loading}
      serverSide
      count={totalCount}
      page={page}
      rowsPerPage={rowsPerPage}
      onTableChange={(action, tableState) => {
        if (action === "changePage") {
          setPage(tableState.page);
        }
      }}
      customToolbarRight={
        <Button
          variant="contained"
          onClick={addService}
          sx={{
            backgroundColor: "#C39B22",
            textTransform: "none",
            fontWeight: 600,
            height: "36px",
            "&:hover": { backgroundColor: "#b18a1f" },
          }}
        >
          Add Service
        </Button>
      }
    />
  );
};

export default ServiceListing;
